import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'

import { TagModel } from '@/domain/model/customer'

export const loadTagsClient = async (): Promise<TagModel[]> => {
  return await makeGetRequest(ApiBase + '/customer_tags')
}
